import React from 'react';

import { down } from '@/assets/icons';
import { ButtonBase, SvgIcon } from '@material-ui/core';
import { Link } from 'react-router-dom';

import styles from './PrevNextButton.module.scss';

export interface IPrevNextButtonProps {
	type: 'prev' | 'next';
	link: string;
}

export const PrevNextButton: React.FC<IPrevNextButtonProps> = ({
	type,
	link,
}) => {
	const prevNextButtonClasses = [
		styles['prev-next-button'],
		styles[`prev-next-button--${type}`],
	];

	return (
		<div className={prevNextButtonClasses.join(' ')}>
			<ButtonBase
				focusRipple
				className={styles['prev-next-button__base']}
				component={Link}
				to={`${link}`}
			>
				<SvgIcon
					component={down}
					className={styles['prev-next-button__icon']}
				/>
			</ButtonBase>
		</div>
	);
};
